// extracted by mini-css-extract-plugin
module.exports = {"descriptionWrapper":"DeactivationConfirmation_descriptionWrapper_2DNz0","subtitle":"DeactivationConfirmation_subtitle_b1lMe","footer":"DeactivationConfirmation_footer_2bDVl"};